import {Component, OnInit} from '@angular/core';
import {UserMachineSubscription} from "../../model/custom/machine/user-machine-subscription";
import {SubscriptionsService} from "../../services/subscriptions.service";
import {SubscriptionFilters} from "../../model/filters/subscription-filters";
import {HierarchyService} from "../../services/hierarchy.service";
import {TimezoneService} from "../../services/timezone.service";

@Component({
  selector: 'app-subscriptions-list',
  templateUrl: './subscriptions-list.component.html',
  styleUrls: ['./subscriptions-list.component.scss']
})
export class SubscriptionsListComponent implements OnInit {

  public subscriptions: UserMachineSubscription[];
  public totalSubscriptions: number;
  public loadingSubscriptions: boolean;

  public startDate: number;
  public endDate: number;
  public availableYearRange: string;

  public hierarchy: any[];
  public organizationCodes: any[];
  public organizations: any[];

  public rows: number = 10;
  public first: number = 0;

  public filtersVisible: boolean;
  public currentFilters: SubscriptionFilters;


  constructor(private subscriptionsService: SubscriptionsService,
              private readonly timezoneService: TimezoneService,
              private hierarchyService: HierarchyService) {
    this.currentFilters = new SubscriptionFilters();
  }

  ngOnInit(): void {
    this.subscriptions = new Array(this.rows);
    this.availableYearRange = this.timezoneService.calcYearRange();
    this.buildTreeNode();
    this.loadSubscriptions();
  }

  private buildTreeNode(): void {
    this.hierarchyService.getHierarchyDropdown().subscribe(response => {
      let responseHierarchy: any[] = this.hierarchyService.getHierarchyTreeNodeFilter(response.hierarchyDto);
      this.hierarchy = responseHierarchy[1];
      this.organizationCodes = responseHierarchy[2].sort((a, b) => a.label > b.label ? 1 : -1);
    });
  }

  private loadSubscriptions(): void {
    this.loadingSubscriptions = true;
    this.subscriptions = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.subscriptionsService.getSubscriptions(this.currentFilters)
      .subscribe(response => {
        let tempMachineSubscriptions = response.machineSubscriptions;
        tempMachineSubscriptions.sort((a, b) =>
          new Date(a.startDate) < new Date(b.startDate) ? 1 : -1);
        this.subscriptions = tempMachineSubscriptions;
        this.totalSubscriptions = this.subscriptions.length;
        this.loadingSubscriptions = false;
      });
  }

  trimFieldsForm(filters: SubscriptionFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  setDate(name: string, value: Date): void {
    if (value) this.currentFilters[name] = this.timezoneService.timestampFromCalendarDataWithTime(value);
    else delete this.currentFilters[name];
  }

  applyFilters(): void {
    this.first = 0;
    if (this.organizations != null && this.organizations.length > 0) {
      this.currentFilters.organizationUuids = this.organizations.map(organization => organization.data);
    } else {
      delete this.currentFilters['organizationUuids'];
    }
    this.loadSubscriptions();
  }

  resetFilters(): void {
    this.currentFilters = new SubscriptionFilters();
    this.startDate = null;
    this.endDate = null;
    this.currentFilters.sortField = 'startDate';
    this.currentFilters.sortOrder = 1;
    this.organizations = [];
  }

}
